import { useRef } from "react";
import { useForkRef } from "@mui/material/utils";

import { type TruncatedTextProps } from "ui/truncated-text/truncated-text.types";

import { useIsTruncated } from "hooks/use-is-truncated";

type UseTruncatedTextProps = Pick<TruncatedTextProps, "ref">;

export const useTruncatedText = ({ ref }: UseTruncatedTextProps) => {
  const measuredRef = useRef<HTMLSpanElement>(null);
  const isTruncated = useIsTruncated(measuredRef);
  const textRef = useForkRef(measuredRef, ref);

  return { textRef, isTruncated };
};
